<template>
    <div class="adv-search-result row">
        <div class="col-xl-3 col-lg-4 col-12 img-col">
            <img v-if="hasImage" class="img-responsive" :src="item.image.src" :alt="item.image.alt"/>
        </div>

        <div class="col-xl-9 col-lg-8 col-12">
            <img v-if="hasLocation" style="position: absolute; right: 10px; top: 10px; cursor: pointer;" width="30px" height="30px"
                 src="/themes/custom/ef2_custom/img/marker.svg" class="custom-marker" @click="handleClick"/>
            <h4 class="pt-2">{{ item.name }}</h4>
            <strong>{{ item.category }}</strong><br/>
            <a :href="item.url" class="cta-link">{{ readMoreTxt }}</a>
        </div>
    </div>
</template>

<script>
export default {
    name: "LocationBlock",

    props: ['item'],

    data() {
        return {
            readMoreTxt: window.Drupal.t('Read more')
        }
    },

    computed: {
        hasImage() {
            return this.item.image.src;
        },
        hasLocation() {
            return this.item.location.lat;
        }
    },

    methods: {
        handleClick() {
            this.$emit('pan-to-map-location', this.item.location)
        }
    }
}
</script>
